import React from 'react';
import Template from './Template';

export default (props) => (
  <Template
    {...props}
    src="/paul-kuan.png"
    name="Paul Kuan"
    position="Director"
    description={(
      <div>
        <p>
          Paul is the Director and driving force behind Premium Capital Partners. He has over 22
          years' experience in key positions for globally recognised organisations in banking,
          finance and corporate advice. He is the proud recipient of several business awards for
          exceptional performance in consumer banking and corporate banking, for both domestic and
          international institutions.
        </p>
        <p>
          Paul is responsible for guiding the corporate strategy of Premium Capital Partners,
          committed to employing his global expertise to develop and deliver effective financing
          solutions to empower Malaysian business. He has a proven track record of developing
          pioneering products for the Malaysian market during his tenure as Product Manager at Hong
          Leong bank, and continued in his role as Product Manager at ABN Amro Bank. Paul went on to
          hold the position of Head of Corporate Cash Management in Global Transaction Services in
          ABN Amro Bank, before moving to become a Partner for Business and Corporate Advisory at
          H20 Capital S/B.
        </p>
        <p>
          Alongside his extensive banking experience, Paul brings to the table 12 years of
          high-level corporate advisory experience from his time at Leverage3 International Limited.
          He has led on corporate advisory projects from balance sheet restructuring for established
          businesses to public listings across a variety of Asia-Pacific markets.
        </p>
      </div>
    )}
    quote="Success isn't just about the bottom line, it's about delivering a product that serves an important purpose. Our goal at Premium Capital Partners is to build solutions that address a gap in the market. Success is that product effectively bridging that gap for our partners and our customers."
  />
)


// WEBPACK FOOTER //
// ./src/screens/OurTeam/Paul.js